export default () => ({
    shareledgers: [],
    shareledgersLoading: false,
    shareledgersInit: true
});
